import React from 'react';
import { Typography } from '@material-ui/core';
import cx from 'classnames';

import useStyles from './styles';
import { translate } from '../../../../utils/helpers';
import cpdLogo from '../../../../assets/images/cpd-logo.png';
import Card from '../../../AnalyticsPage/components/Card';
import { CardWrapper } from '../../../../components/UI/CardWrapper';
import { PathwayLogo } from '../../../../components/TestResults';

interface PathwayInformationProps {
  showInfo?: boolean;
  cpdCredits?: string | null;
  wrapperClass?: string;
  tenantCircleUrl?: string | null;
  pathwaySvg?: string | null;
}

const PathwayInformation: React.FC<PathwayInformationProps> = ({
  showInfo,
  cpdCredits,
  tenantCircleUrl,
  pathwaySvg,
  wrapperClass = '',
}) => {
  const classes = useStyles();

  return (
    <div className={cx(classes.wrapper, wrapperClass)}>
      <Card
        title={translate('page.analytics.cpdCredits')}
        value={cpdCredits}
        type={null}
        activeType={null}
        chart={false}
        className={classes.card}
      >
        <img src={cpdLogo} alt="CPD certification" />
      </Card>
      {showInfo && (
        <CardWrapper>
          {pathwaySvg && <PathwayLogo circleUrl={tenantCircleUrl} svgContent={pathwaySvg} />}
          <Typography variant="h4" component="h4" className={classes.cardTitle}>
            {translate('page.pathway.certificates')}
          </Typography>
          <Typography className={classes.cardDescription}>
            {translate('page.pathway.certificatesText')}
          </Typography>
        </CardWrapper>
      )}
    </div>
  );
};

export default PathwayInformation;
